// One table for the player's key handler, its tooltips and the footer hint.
// method/arg name the ClipComponent call; repeat lets a held key fire again; anyAsset needs no video.
export const SHORTCUTS = {
  play: { key: " ", label: "Space", text: "Play / Pause", method: "togglePlay" },
  pause: { key: "k", label: "K", text: "Pause", method: "pause" },
  back10: { key: "j", label: "J", text: "Back 10 s", method: "seekBy", arg: -10, repeat: true },
  fwd10: { key: "l", label: "L", text: "Forward 10 s", method: "seekBy", arg: 10, repeat: true },
  prevFrame: { key: "ArrowLeft", label: "←", text: "Previous frame", method: "stepFrame", arg: -1, repeat: true },
  nextFrame: { key: "ArrowRight", label: "→", text: "Next frame", method: "stepFrame", arg: 1, repeat: true },
  markIn: { key: "i", label: "I", text: "Set In at playhead", method: "setMarkIn" },
  markOut: { key: "o", label: "O", text: "Set Out at playhead", method: "setMarkOut" },
  clearMarks: { key: "x", label: "X", text: "Clear In/Out", method: "clearMarks" },
  addSubclip: { key: ".", label: ".", text: "Add clip", method: "addClip" },
  gotoTc: { key: "g", label: "G", text: "Jump to a timecode", method: "editTc" },
  note: { key: "n", label: "N", text: "Comment for the next clip", method: "openComment" },
  metadata: { key: "m", label: "M", text: "Metadata & comment", method: "toggleMetadata", anyAsset: true },
};

export const SHORTCUT_HINT = "Space play · J/L ±10s · I/O mark";

/** e.g. "Back 10 s (J)" */
export function tip(name) {
  const shortcut = SHORTCUTS[name];
  return shortcut.text + " (" + shortcut.label + ")";
}

export function shortcutFor(event) {
  const key = event.key.length === 1 ? event.key.toLowerCase() : event.key;
  return Object.values(SHORTCUTS).find((shortcut) => shortcut.key === key);
}

export function isTypingTarget(el) {
  return !!el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT" || el.isContentEditable);
}

export function isOverlayOpen(state) {
  return state.adminOpen || state.uploadOpen || state.dialog.visible || state.permissionsDialog.visible;
}
